import _ from 'underscore';

const SOVColumns = {
  ImpShare: 'AuctionWonPercent',
  ImpShareLostToBudget: 'AuctionLostToBudgetPercent',
  ImpShareLostToRank: 'AuctionLostToRankPercent',
  ImpShareLostToAdRelevance: 'AuctionLostToLandingPercent',
  ImpShareLostToExpectedCTR: 'AuctionLostToAdQualityPercent',
  ImpShareLostToBid: 'AuctionLostToBidPercent',
};

export default _.mapObject(SOVColumns, property => `PerformanceMetrics/${property}`);
